import { callYm } from '@/js/metrika.ts';

/** Идентификаторы JS-целей, заведённых в счётчике 43808394. */
export const GOALS = {
  /** Шаг 1 воронки «Оформление корзины» — добавление товара в корзину. */
  ADD_TO_BASKET: 'AddtoBasket',
  /** Шаг 3 воронки «Оформление корзины» — открытие страницы оформления. */
  CHECKOUT: 'Checkout',
  /** Шаг 4 воронки «Оформление корзины» — заказ успешно создан. */
  SEND: 'Send',
  /** Страница успешного заказа. */
  ORDER_SUCCESS: 'order-success',
  ONE_CLICK: 'one-click',
  FEEDBACK_FORM: 'feedback-form',
  CLICK_WHATSAPP: 'click-whatsapp',
  CLICK_TELEGRAM: 'click-telegram',
  YANDEX_MARKET: 'yandex_market',
  WILDBERRIES: 'link_wb',
  AVITO: 'avito',
} as const;

/** Максимальное ожидание подтверждения от Метрики перед уходом со страницы. */
const GOAL_CALLBACK_TIMEOUT = 700;

export function reachGoal(name: string, params?: Record<string, unknown>) {
  if (!name) {
    return;
  }
  if (params) {
    callYm('reachGoal', name, params);
    return;
  }
  callYm('reachGoal', name);
}

/**
 * Отправляет цель и ждёт подтверждения счётчика, но не дольше таймаута.
 * Нужно там, где сразу после цели выполняется переход на другую страницу.
 */
export async function reachGoalAsync(name: string, params?: Record<string, unknown>): Promise<void> {
  if (!name || typeof window.ym !== 'function') {
    return;
  }

  return new Promise<void>((resolve) => {
    const timer = window.setTimeout(resolve, GOAL_CALLBACK_TIMEOUT);
    callYm('reachGoal', name, params ?? {}, () => {
      window.clearTimeout(timer);
      resolve();
    });
  });
}

/**
 * Цели на клик. Кроме явных js-классов ловим ссылки по href: часть ссылок
 * на мессенджеры живёт в мобильном меню, которое mmenu-js клонирует из
 * `<template>` уже после инициализации.
 */
const CLICK_GOALS: { selector: string, goalName: string }[] = [
  {
    selector: '.js-click-whatsapp-goal, a[href*="wa.me"], a[href*="whatsapp.com"]',
    goalName: GOALS.CLICK_WHATSAPP,
  },
  {
    selector: '.js-click-telegram-goal, a[href*="t.me/"]',
    goalName: GOALS.CLICK_TELEGRAM,
  },
  {
    selector: '.js-click-yandex-market-goal',
    goalName: GOALS.YANDEX_MARKET,
  },
  {
    selector: '.js-click-wb-goal',
    goalName: GOALS.WILDBERRIES,
  },
  {
    selector: '.js-click-avito-goal',
    goalName: GOALS.AVITO,
  },
];

export function initReachGoals() {
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }
    const goal = CLICK_GOALS.find(({ selector }) => target.closest(selector));
    if (goal) {
      reachGoal(goal.goalName);
    }
  }, { capture: true });
}
